<template>
  <div>
    <div
      class="user-header flex h-[var(--header-height)] shrink-0 items-center justify-between space-x-6 border-b px-6 text-sm font-medium transition-all"
      :class="{ 'lg:-mt-[var(--header-height)]': minimalUI }"
    >
      <div class="flex items-center">
        <nav class="flex items-center space-x-6">
          <NuxtLink to="/">
            <img
              class="block h-6 w-6"
              src="/ag-avatar.svg"
              alt="Approach Guides"
            />
          </NuxtLink>
          <div
            v-if="!$route.meta.hideNav"
            class="hidden lg:flex lg:items-center lg:space-x-6"
          >
            <NuxtLink
              to="/"
              class="user-header__link"
            >{{ $t("home") }}</NuxtLink>
            <NuxtLink
              to="/experiences"
              class="user-header__link"
            >{{ $t("experiences") }}</NuxtLink>
            <NuxtLink
              to="/websites"
              class="user-header__link"
            >{{ $t("websites") }}</NuxtLink>
          </div>
        </nav>
      </div>

      <div class="flex items-center space-x-6">
        <ProfileStatus v-if="user?.profile_completion_percentage !== 100" />
        <LanguageDropdown />
        <UserMenu v-if="$route.name !== 'login' && $route.name !== 'signup'" />
        <a
          class="flex cursor-pointer text-paragraph hover:text-primary lg:hidden"
          @click="toggleSidebar"
        >
          <Icon
            icon="bars"
            prefix="far"
            class="text-base"
          />
        </a>
      </div>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
const { isLoggedIn, user } = useAuth()
const { showMobileSidebar, minimalUI } = useLayoutState()
const toggleSidebar = () => (showMobileSidebar.value = !showMobileSidebar.value)
</script>

<style>
.user-header {
  &__link {
    @apply flex h-[var(--header-height)] items-center border-y-2 border-transparent font-semibold text-gray-500 hover:text-primary;

    &.router-link-exact-active {
      @apply border-b-primary text-primary;
    }
  }
}
</style>
